import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Avatar from '@material-ui/core/Avatar';
import Typography from '@material-ui/core/Typography';
import { Box } from '@material-ui/core';
import { WIDGET } from 'utils/constants/css';
import isEmpty from 'lodash/isEmpty';
import { useTranslation } from 'react-i18next';
import { eventsNewsFeed } from 'utils/constants/eventStatus';
import { useDispatch } from 'react-redux';
import { eventsGridActions } from 'containers/Pages/Events';
import { openDetails } from 'reducers/ui';
import { PAGE_URLS } from 'utils/constants';
import { useHistory } from 'react-router-dom';
import { updateURLQueryString } from 'sagas/user/help';

const NewsFeed = data => {
  const classes = useStyles();
  const { data: eventList } = data;
  const { t } = useTranslation();

  const dispatch = useDispatch();
  const history = useHistory();
  return (
    <>
      <List className={classes.notifications} classes={{ root: classes.root }}>
        <Box component={'div'} className={classes.header}>
          <span className={classes.headerTitle}>{t(eventsNewsFeed.title)}</span>
        </Box>

        {!isEmpty(eventList) &&
          eventList.map((event, index) => (
            <ListItem
              button
              alignItems="flex-start"
              key={index}
              className={classes.list}
              onClick={() => {
                dispatch(openDetails(PAGE_URLS.EVENTS.link));
                dispatch(eventsGridActions.setSelectedRowID(event.id));
                history.push(PAGE_URLS.EVENTS.link); // change react route
                updateURLQueryString(PAGE_URLS.EVENTS.link); // update the url parameter in redux
              }}
            >
              <ListItemAvatar>
                <Avatar alt={event.title} src={event.thumbnail} />
              </ListItemAvatar>
              <ListItemText
                primary={event.title}
                secondary={
                  <React.Fragment>
                    <Typography
                      component="span"
                      variant="body2"
                      className={classes.inline}
                      color="textPrimary"
                    >
                      {event.creatorName}
                    </Typography>
                    <Box component="span" className={classes.content}>
                      {t(event.status)} | {event.lastUpdatedTime}
                    </Box>
                    <Box component="span" className={classes.content}>
                      {event.address}
                    </Box>
                  </React.Fragment>
                }
              />
            </ListItem>
          ))}
      </List>
    </>
  );
};

const useStyles = makeStyles(theme => ({
  root: {
    '&::-webkit-scrollbar': {
      width: '0.7em',
    },
    '&::-webkit-scrollbar-track': {
      boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
      webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
    },
    '&::-webkit-scrollbar-thumb': {
      borderRadius: '10px',
      backgroundColor: theme.palette.primary.main,
    },
    '& ::-webkit-scrollbar-corner': {
      backgroundColor: theme.palette.background.paper,
    },
  },
  button: {},
  header: {
    paddingLeft: '5px',
    marginBottom: '5px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'start',
  },
  headerTitle: {
    textAlign: 'left',
    fontWeight: 'bold',
    fontSize: '14px',
    color: 'rgb(160, 160, 160)',
    borderBottom: '5px',
  },
  notifications: {
    height: WIDGET.NEWSFEED.height,
    overflow: 'auto',
  },
  inline: {
    display: 'flex',
    color: theme.palette.text.secondary,
  },
  content: {
    display: 'flex',
    color: theme.palette.text.secondary,
    '& ::-webkit-scrollbar-thumb': {
      borderRadius: '10px',
      backgroundImage:
        '-webkit-gradient(linear, left bottom, left top, color-stop(0.44, rgb(159, 155, 200)), color-stop(0.72, rgb(122, 115, 198)),color-stop(0.86, rgb(93, 84, 196)))',
    },
  },
  list: {
    background: theme.palette.background.paper,
    marginBottom: '5px',
  },
}));

export default NewsFeed;
